/* eslint-disable no-nested-ternary */
import {
  Button, notification, Select,
  Spin,
  Tooltip,
} from 'antd';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { InfoCircleOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';
import SelectDepartment from '@Components/Common/SelectDepartment';
import H3DateSelector from '@Uilib/h3DateSelector';
import CategoryFilterNew from '@Components/Common/CategoryFilterNew';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import reportV2Actions from '../../../actions/Reports/reportV2Actions';
import ScheduledReport from '../ScheduledReport';
import './style.scss';
import CustomColumnsGlossary from '../CustomColumnsGlossary';
import PRZSelect from '../../Common/UI/PRZSelect';

const { Option } = Select;

const ReportFilterForm = ({
  user, reportData, filterReportsV2ListLoading, filterReportsV2List, callback, getReportsById, getReportsByIdLoading,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedInterval, setSelectedInterval] = useState('this_month');
  const [selectedDueDateInterval, setSelectedDueDateInterval] = useState(null);
  const [startDateMomentEpoch, setStartDateMomentEpoch] = useState(dayjs().startOf('month').valueOf());
  const [endDateMomentEpoch, setEndDateMomentEpoch] = useState(dayjs().endOf('month').valueOf());
  const [startDueDateMomentEpoch, setStartDueDateMomentEpoch] = useState(null);
  const [endDueDateMomentEpoch, setEndDueDateMomentEpoch] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState([]);
  // const [selectedTenant, setSelectedTenant] = useState([user?.tenant_info?.tenant_id]);
  const [selectedEmails, setSelectedEmails] = useState([user.username]);
  const [dropdownValues, setDropdownValues] = useState([]);
  const [ScheduledReportData, setScheduledReportData] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [numberInputs, setNumberInputs] = useState([]);
  const [glossaryData, setGlossaryData] = useState([]);
  const [isGlossaryEnabled, setIsGlossaryEnabled] = useState(false);
  const [saveGlossaryConfiguration, setSaveGlossaryConfiguration] = useState(true);

  useEffect(() => {
    if (reportData?.report_id) {
      getReportsById({ report_id: reportData?.report_id }, (callbackData) => {
        // Search for the matching report by report_id
        const matchingGlossary = callbackData?.report_groups?.flatMap(group =>
          group?.report_list?.filter(report => report.report_id === reportData?.report_id)
        )?.[0]?.glossary;
        // Set glossary data only if the report_id matches
        if (matchingGlossary) {
          setGlossaryData(matchingGlossary);
        } else {
          setGlossaryData([]); // Set empty if no match
        }
      });
    }
  }, [reportData]);

  const updateDate = ({ startDate, endDate, isDueDate }) => {
    if (isDueDate) {
      setStartDueDateMomentEpoch(startDate);
      setEndDueDateMomentEpoch(endDate);
    } else {
      setStartDateMomentEpoch(startDate);
      setEndDateMomentEpoch(endDate);
    }
  };

  const handleDateChange = (value, isDueDate) => {
    if (isDueDate) {
      setSelectedDueDateInterval(value);
    } else {
      setSelectedInterval(value);
    }
    if (value === 'today') {
      updateDate({
        startDate: dayjs().utc().startOf('day').valueOf(),
        endDate: dayjs().utc().endOf('day').valueOf(),
        isDueDate,
      });
    }
    if (value === 'yesterday') {
      updateDate({
        startDate: dayjs().utc().subtract(1, 'days').startOf('day')
          .valueOf(),
        endDate: dayjs().utc().subtract(1, 'days').endOf('day')
          .valueOf(),
        isDueDate,
      });
    }
    if (value === 'this_week') {
      updateDate({ startDate: dayjs().utc().startOf('week').valueOf(), endDate: dayjs().utc().endOf('week').valueOf(), isDueDate });
    }
    if (value === 'last_week') {
      updateDate({
        startDate: dayjs().utc().subtract(1, 'weeks').startOf('week')
          .valueOf(),
        endDate: dayjs().utc().subtract(1, 'weeks').endOf('week')
          .valueOf(),
        isDueDate,
      });
    }
    if (value === 'this_month') {
      updateDate({
        startDate: dayjs().utc().startOf('month').valueOf(),
        endDate: dayjs().utc().endOf('month').valueOf(),
        isDueDate,
      });
    }
    if (value === 'last_month') {
      updateDate({
        startDate: dayjs().utc().subtract(1, 'months').startOf('month')
          .valueOf(),
        endDate: dayjs().utc().subtract(1, 'months').endOf('month')
          .valueOf(),
        isDueDate,
      });
    }
    if (value === 'this_quarter') {
      updateDate({
        startDate: dayjs().utc().quarter(dayjs().utc().quarter()).startOf('quarter')
          .valueOf(),
        endDate: dayjs().utc().endOf('quarter').valueOf(),
        isDueDate,
      });
    }
    if (value === 'last_quarter') {
      updateDate({
        startDate: dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
          .startOf('quarter')
          .valueOf(),
        endDate: dayjs().utc().quarter(dayjs().utc().quarter()).subtract(1, 'quarter')
          .endOf('quarter')
          .valueOf(),
        isDueDate,
      });
    }
    if (value === 'this_year') {
      updateDate({
        startDate: dayjs().utc().startOf('years').valueOf(),
        endDate: dayjs().utc().endOf('years').valueOf(),
        isDueDate,
      });
    }
    if (value === 'last_year') {
      updateDate({
        startDate: dayjs().utc().subtract(1, 'years').startOf('years')
          .valueOf(),
        endDate: dayjs().utc().subtract(1, 'years').endOf('years')
          .valueOf(),
        isDueDate,
      });
    }
    if (value === 'customize') {
      if (isDueDate) {
        setStartDueDateMomentEpoch(null);
        setEndDueDateMomentEpoch(null);
      } else {
        setStartDateMomentEpoch(null);
        setEndDateMomentEpoch(null);
      }
    }
  };

  const handleDropdownChange = (filter, value) => {
    const index = dropdownValues?.findIndex((item) => item.payload_key_name === filter.payload_key_name);

    if (!value) {
      // do nothing
    } else if (index !== -1) {
      const updatedValues = [...dropdownValues];
      updatedValues[index] = { ...updatedValues[index], value };
      setDropdownValues(updatedValues);
    } else {
      setDropdownValues([...dropdownValues, { payload_key_name: filter.payload_key_name, value }]);
    }
  };

  useEffect(() => {
    if (reportData?.filtersValues) {
      const filtersValues = reportData?.filtersValues;
      const startDate = filtersValues?.from_Date;
      const endDate = filtersValues?.to_Date;
      const departmentIds = filtersValues?.department_ids?.map((item) => parseInt(item));
      const recipientEmails = filtersValues?.recipient_emails;
      const productCategoryIds = filtersValues?.product_category_ids;
      const scheduleConfiguration = filtersValues?.schedule_configuration;
      const costingMethod = filtersValues?.costing_method;
      const tenantIds = filtersValues?.tenant_ids;
      const moStatus = filtersValues?.mo_status;
      const showRawMaterial = filtersValues?.show_raw_material;
      const numberInput = filtersValues;

      if (startDate && endDate) {
        setStartDateMomentEpoch(startDate);
        setEndDateMomentEpoch(endDate);
        setSelectedInterval('customize');
      }
      if (departmentIds) {
        setSelectedDepartment(departmentIds);
      }

      if (recipientEmails) {
        setSelectedEmails(recipientEmails);
      }

      if (productCategoryIds) {
        setSelectedCategory(productCategoryIds);
      }

      // if (tenantIds) {
      //   setSelectedTenant(tenantIds);
      // }

      if (scheduleConfiguration) {
        setScheduledReportData(scheduleConfiguration);
      }

      if (costingMethod) {
        // Ensure that costingMethod is not an array but a single value
        setDropdownValues((prevValues) => [...prevValues, { payload_key_name: 'costing_method', value: costingMethod }]);
      }

      if (tenantIds) {
        setDropdownValues((prevValues) => [...prevValues, { payload_key_name: 'tenant_ids', value: tenantIds }]);
      }

      if (moStatus) {
        setDropdownValues((prevValues) => [...prevValues, { payload_key_name: 'mo_status', value: moStatus }]);
      }

      if (showRawMaterial) {
        setDropdownValues((prevValues) => [...prevValues, { payload_key_name: 'show_raw_material', value: showRawMaterial }]);
      }

      if (numberInput) {
        setNumberInputs(numberInput);
      }
    } else {
      const numberInputsDefaultVal = reportData?.report_filters?.map((filter) => {
        if (filter.type === 'NUMBER_INPUT') {
          return { payload_key_name: filter.payload_key_name, value: filter.default_value };
        }
        return null;
      });
      const dropdownValuesDefaultVal = reportData?.report_filters?.filter((filter) => filter.type === 'DROPDOWN')?.map((filter) => ({ payload_key_name: filter.payload_key_name, value: ((filter.payload_key_name === 'tenant_ids') ? user.tenant_info.tenant_id : filter.default_value) }));
      setDropdownValues(dropdownValuesDefaultVal?.filter((val) => val !== null || val !== 'undefined') || []);
      setNumberInputs(numberInputsDefaultVal);
    }
  }, [reportData]);

  const isFilterValueProvided = (filter) => {
    switch (filter.type) {
      case 'DATE_RANGE':
        return startDateMomentEpoch !== null && endDateMomentEpoch !== null;
      case 'CATEGORY_SELECTOR':
        return selectedCategory.length > 0;
      // case 'TENANT_SELECTOR':
      //   return selectedTenant.length > 0;
      case 'DEPARTMENT_SELECTOR':
        return selectedDepartment.length > 0;
      case 'DROPDOWN': {
        const _tmp = dropdownValues.filter((i) => (i.payload_key_name === filter.payload_key_name));
        return (_tmp?.[0]?.value && _tmp.length > 0);
      }
      case 'NUMBER_INPUT':
        return numberInputs.length > 0;
      default:
        return false;
    }
  };

  function conditionCheck(filter) {
    let finalResult = true;
    if (filter?.condition?.is_scheduled_report === true) {
      if ((ScheduledReportData?.isScheduledReport || false) === true) {
        finalResult = true;
      } else finalResult = false;
    } else if (filter?.condition?.is_scheduled_report === false) {
      if ((ScheduledReportData?.isScheduledReport || false) === true) {
        finalResult = false;
      } else finalResult = true;
    }
    return finalResult;
  }

  const isValidSchedule = () => {
    if (ScheduledReportData?.isScheduledReport) {
      if (ScheduledReportData?.selectedFrequency === 'DAILY' && !ScheduledReportData?.selectedTime) {
        return false;
      } if (ScheduledReportData?.selectedFrequency === 'ONCE' && (ScheduledReportData?.selectedTime || ScheduledReportData?.selectedDate)) {
        return false;
      } if (ScheduledReportData?.selectedFrequency === 'WEEKLY' && (ScheduledReportData?.selectedTime || !ScheduledReportData?.selectedDays?.length)) {
        return false;
      } if (ScheduledReportData?.selectedFrequency === 'MONTHLY' && (ScheduledReportData?.selectedTime || !ScheduledReportData?.selectedDate)) {
        return false;
      } return true;
    }
    return true;
  };

  const loadReportsDownloadData = () => {
    try {
      let glossaryArray = [];
      if (isGlossaryEnabled) {
        glossaryArray = Object.keys(selectedItems).map((key, index) => ({
          key_id: key,
          key_name: selectedItems?.[key]?.key_name,
          key_info: selectedItems?.[key]?.key_info,
          key_seq: index + 1,
        }));
        if (!glossaryArray?.length) {
          throw new Error('Please Select Columns, columns selected are 0');
        }
      }
      setFormSubmitted(true);

      const numberInputsPayload = numberInputs
        ?.filter((input) => input && input.value !== '' && input.value !== null && input.value !== undefined)
        ?.map((input) => ({
          [input.payload_key_name]: input.value,
        }));
      const finalFilters = reportData?.report_filters?.filter((i) => conditionCheck(i));
      const missingFilters = finalFilters?.filter((filter) => filter.required && !isFilterValueProvided(filter));
      if (missingFilters.length === 0 && isValidSchedule()) {
        const payload = {
          report_id: reportData?.report_id,
          is_direct_download: true,
          is_scheduled_report: ScheduledReportData?.isScheduledReport || false,
          is_email_report: selectedEmails.length > 0,
          from_Date: startDateMomentEpoch,
          to_Date: endDateMomentEpoch,
          from_due_date: startDueDateMomentEpoch,
          to_due_date: endDueDateMomentEpoch,
          department_ids: selectedDepartment,
          recipient_emails: selectedEmails,
          product_category_ids: selectedCategory,
          save_glossary: saveGlossaryConfiguration,
          schedule_configuration: {
            time: ScheduledReportData?.selectedTime,
            type: ScheduledReportData?.selectedFrequency,
            days: ScheduledReportData?.selectedDays,
            date: ScheduledReportData?.selectedDate ? ScheduledReportData?.selectedFrequency === 'MONTHLY' ? ScheduledReportData?.selectedDate.date() : dayjs(ScheduledReportData?.selectedDate).format('DD-MM-YYYY') : null,
          },
          ...numberInputsPayload.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
        };
        if (isGlossaryEnabled) payload.glossary = glossaryArray;
        const dropDownTypeFilters = finalFilters.filter((i) => (i.type === 'DROPDOWN')).map((i) => i.payload_key_name);
        dropdownValues.filter((i) => (dropDownTypeFilters.includes(i.payload_key_name))).forEach(({ payload_key_name, value }) => {
          payload[payload_key_name] = !Array.isArray(value) ? [value] : value;
        });
        filterReportsV2List(payload, () => { callback(); });
      } else {
        let missingFieldNames = missingFilters.map((filter) => filter.label).join(', ');
        let errorMessage = `You are missing value for the following field: ${missingFieldNames || (!isValidSchedule() ? 'Schedule Information' : '')}`;
        if (missingFilters.length > 1) {
          missingFieldNames = missingFilters.map((filter) => filter.label).join(', ');
          errorMessage = `You are missing values for the following fields: ${missingFieldNames || (!isValidSchedule() ? 'Schedule Information' : '')}`;
        }
        notification.open({
          type: 'error',
          message: errorMessage,
          placement: 'top',
          duration: 5,
        });
      }
    } catch (error) {
      notification.open({
        type: 'error',
        message: error.message,
        placement: 'top',
        duration: 5,
      });
    }
  };

  const handleNumberInputChange = (index, value) => {
    const updatedInputs = [...numberInputs];
    updatedInputs[index] = { payload_key_name: reportData.report_filters[index].payload_key_name, value };
    setNumberInputs(updatedInputs);
  };

  const reportFilters = reportData.report_filters.filter((i) => conditionCheck(i));

  const tenantIdsValue = Array.isArray(dropdownValues?.find((item) => item?.payload_key_name === 'tenant_ids')?.value)
    ? dropdownValues?.find((item) => item?.payload_key_name === 'tenant_ids')?.value
    : dropdownValues?.find((item) => item?.payload_key_name === 'tenant_ids')?.value
      ? [dropdownValues?.find((item) => item?.payload_key_name === 'tenant_ids')?.value]
      : [];

  return (
    <Spin spinning={getReportsByIdLoading}>
      <div className="report-form__wrapper">
        <div className="ant-row custom-responsive-row">
          {/* Rendering filters based on the report data */}
          {reportFilters.map((filter, index) => (
            <div key={filter?.label} className="ant-col-md-12">
              <H3Text text={filter.label} className="report-form__label" required={filter.required} infoMessage={filter.info} />
              {filter.type === 'DATE_RANGE' && (
                <H3DateSelector
                  selectedInterval={selectedInterval}
                  onListChange={(value) => handleDateChange(value)}
                  startDate={startDateMomentEpoch}
                  endDate={endDateMomentEpoch}
                  onDateChange={(date) => {
                    setStartDateMomentEpoch(dayjs(date[0])?.valueOf());
                    setEndDateMomentEpoch(dayjs(date[1])?.endOf('day')?.valueOf());
                    setSelectedInterval('customize');
                  }}
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                />
              )}
              {filter.type === 'DUE_DATE_RANGE' && (
                <H3DateSelector
                  selectedInterval={selectedDueDateInterval}
                  onListChange={(value) => handleDateChange(value, true)}
                  startDate={startDueDateMomentEpoch}
                  endDate={endDueDateMomentEpoch}
                  onDateChange={(date) => {
                    setStartDueDateMomentEpoch(dayjs(date[0])?.valueOf());
                    setEndDueDateMomentEpoch(dayjs(date[1])?.endOf('day')?.valueOf());
                    setSelectedDueDateInterval('customize');
                  }}
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                />
              )}
              {filter.type === 'CATEGORY_SELECTOR' && (
                <CategoryFilterNew
                  onChange={(value) => setSelectedCategory(value)}
                  selectedCategory={selectedCategory}
                  hideTitle
                  placeholder="Select category.."
                  multiple={!filter.multi_select}
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                />
              )}
              {/* {filter.type === 'TENANT_SELECTOR' && (
                <TenantSelector
                  selectedTenant={selectedTenant}
                  showSearch
                  noDropdownAlign
                  onChange={(value) => setSelectedTenant(value)}
                  placeholder="Select Business Unit"
                  isMultiple={filter.multi_select}
                  hideTitle
                  showError={formSubmitted && selectedTenant?.length < 1}
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                  includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)}
                />
              )} */}
              {filter.type === 'NUMBER_INPUT' && (
                <H3FormInput
                  type="number"
                  containerClassName="orgInputContainer create-category-input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput type-number"
                  onChange={(event) => handleNumberInputChange(index, event.target.value)}
                  maxLength="10"
                  required
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                  value={numberInputs[index]?.value || numberInputs[filter?.payload_key_name]}
                />
              )}
              {filter.type === 'DEPARTMENT_SELECTOR' && (
                <SelectDepartment
                  title="Department"
                  hideTitle
                  selectedDepartment={selectedDepartment}
                  // tenantId={tenantIdsValue?.length === 1 ? tenantIdsValue?.[0] : null}
                  noDropdownAlign
                  onChange={(value) => {
                    if (filter.multi_select) {
                      setSelectedDepartment(value);
                    } else {
                      setSelectedDepartment([value?.department_id]);
                    }
                  }}
                  isMultiple={filter.multi_select}
                  emptyNotAllowed
                  showSearch
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                  multipleSelectedTenantIds={tenantIdsValue.join(',')}
                  containerClassName="report__dept-wrapper"
                />
              )}
              {filter.type === 'DROPDOWN' && (
                <PRZSelect
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  value={dropdownValues?.find((item) => item?.payload_key_name === filter.payload_key_name)?.value}
                  onChange={(value) => {
                    if (value.includes('all')) {
                      const isSelectAll = value?.length === filter?.dropdown_values.length + 1;
                      const allValues = isSelectAll ? [] : filter?.dropdown_values?.map((dropdown) => dropdown?.value);
                      handleDropdownChange(filter, allValues);
                    } else {
                      handleDropdownChange(filter, value);
                    }
                  }}
                  placeholder={`Select ${filter?.label}`}
                  loading={filterReportsV2ListLoading}
                  maxTagCount="responsive"
                  mode={filter?.multi_select ? 'multiple' : undefined}
                  disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                >
                  {/* Conditionally render "Select All" option */}
                  {filter?.multi_select && filter?.dropdown_values?.length <= 50 && (
                    <Select.Option key="all" value="all">
                      {dropdownValues?.find((item) => item?.payload_key_name === filter?.payload_key_name)?.value?.length === filter?.dropdown_values?.length
                        ? 'Unselect All'
                        : 'Select All'}
                    </Select.Option>
                  )}
                  {filter?.dropdown_values?.map((dropdown, _index) => (
                    <Select.Option key={_index} value={dropdown.value}>
                      {dropdown.name}
                    </Select.Option>
                  ))}
                </PRZSelect>
              )}
            </div>
          ))}
          {reportData?.download_methods?.includes('EMAIL') && (
            <div className="ant-col-md-12">
              <H3Text text="Recipient Email Addresses" className="report-form__label" />
              <PRZSelect
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                mode="tags"
                filterOption={false}
                value={selectedEmails}
                onChange={(value) => setSelectedEmails(value)}
                placeholder="Enter email address"
                maxTagCount="responsive"
                disabled={filterReportsV2ListLoading || reportData?.filtersValues}

              >
                {selectedEmails.length > 0 ? (
                  selectedEmails.map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))
                ) : (
                  <Option key={user?.email} value={user?.email}>
                    {user?.email}
                  </Option>
                )}
              </PRZSelect>
            </div>
          )}
          <div className="ant-col-md-24">
            {glossaryData?.length > 0 && (
              <CustomColumnsGlossary
                disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                glossaryData={glossaryData}
                setSelectedItems={setSelectedItems}
                selectedItems={selectedItems}
                enable={reportData?.glossary_selection_enabled}
                setIsGlossaryEnabled={setIsGlossaryEnabled}
                isGlossaryEnabled={isGlossaryEnabled}
                saveGlossaryConfiguration={saveGlossaryConfiguration}
                setSaveGlossaryConfiguration={setSaveGlossaryConfiguration}
              />
            )}
          </div>
          <div className="ant-col-md-24">
            {reportData?.download_methods?.includes('SCHEDULED_REPORT') && user?.tenant_info?.global_config?.settings?.enable_report_scheduling && (
              <ScheduledReport
                allowedDurations={['DAILY', 'ONCE', 'WEEKLY', 'MONTHLY']}
                setScheduledReportData={setScheduledReportData}
                disabled={filterReportsV2ListLoading || reportData?.filtersValues}
                alwaysOn={false}
              />
            )}
          </div>
          {/* Submit button */}
          {!reportData?.filtersValues && (
            <div className="ant-col-md-24">
              <Button
                type="primary"
                style={{ marginTop: '30px' }}
                loading={filterReportsV2ListLoading}
                onClick={() => loadReportsDownloadData(reportFilters)}
              >
                Submit
              </Button>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers, ReportV2Reducers,
}) => ({
  user: UserReducers.user,
  filterReportsV2ListLoading: ReportV2Reducers.filterReportsV2ListLoading,
  getReportsByIdLoading: ReportV2Reducers.getReportsByIdLoading,

});

const mapDispatchToProps = (dispatch) => ({
  filterReportsV2List: (params, callback) => dispatch(reportV2Actions.filterReportsV2List(params, callback)),
  getReportsById: (params, callback) => dispatch(reportV2Actions.getReportsById(params, callback)),
});

ReportFilterForm.propTypes = {
  user: PropTypes.object,
  reportData: PropTypes.object,
  filterReportsV2ListLoading: PropTypes.bool,
  filterReportsV2List: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportFilterForm));
